import React from 'react'
import PropTypes from 'prop-types'
import {
    Accordion as Wrapper,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'

export default function Accordion({ content }) {
    return (
        <Wrapper allowZeroExpanded>
            {content.map(({ question, answer }) => (
                <AccordionItem key={question}>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            {question}
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {answer.map((item) => (
                            <p key={item}>{item}</p>
                        ))}
                    </AccordionItemPanel>
                </AccordionItem>
            ))}
        </Wrapper>
    )
}

Accordion.propTypes = {
    content: PropTypes.arrayOf(PropTypes.object).isRequired,
}
